import { render } from "./speechvue.vue?vue&type=template&id=3e015cee&scoped=true"
import script from "./speechvue.vue?vue&type=script&lang=js"
export * from "./speechvue.vue?vue&type=script&lang=js"

import "./speechvue.vue?vue&type=style&index=0&id=3e015cee&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e015cee"]])

export default __exports__